import { render, staticRenderFns } from "./ReservationOnlyDetailsWidget.vue?vue&type=template&id=eec958b0"
import script from "./ReservationOnlyDetailsWidget.vue?vue&type=script&lang=js"
export * from "./ReservationOnlyDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports